import { AttendantService } from '@/services/attendant.service';
import { queryOptions } from '@tanstack/react-query';

export const listAttendantsQuery = queryOptions({
  queryKey: ['list-attendants'],
  queryFn: AttendantService.list,
});

export const getAttendantQuery = (id: number) => queryOptions({
  queryKey: ['get-attendant', id],
  queryFn: () => AttendantService.get(id),
}); 